import axios from "axios";

// export const API_ROUTES = "https://suntech.tulip-software.com/api/";
// export const API_ROUTES = "http://65.20.78.110/api/";
// export const API_ROUTES = "http://gold.i1iot.com/api/";
export const API_ROUTES = "https://api.dubaijewellerygroup.com/api/";
// export const API_ROUTES = "http://185.56.89.191:8056/api/";

// export const SOCKET_URL = "wss://suntech.tulip-software.com/ws/";
// export const SOCKET_URL = "wss://65.20.78.110/ws";
// export const SOCKET_URL = "wss://gold.i1iot.com/ws";
export const SOCKET_URL = "wss://api.dubaijewellerygroup.com/ws";
// export const SOCKET_URL = "wss://185.56.89.191:8056/ws";

// const API_BASE_URL = "https://suntech.tulip-software.com/api/";
// const API_BASE_URL = "http://65.20.78.110/api/";
// const API_BASE_URL = "http://gold.i1iot.com/api/";
const API_BASE_URL = "https://api.dubaijewellerygroup.com/api/";
// const API_BASE_URL = "http://185.56.89.191:8056/api/";

const token = localStorage.getItem("jwtToken");

// Create an instance of axios with default settings
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token || localStorage.getItem("jwtToken")}`,
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// CRUD operations
export const get = async (endpoint, params = {}) => {
  try {
    const response = await apiClient.get(endpoint, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const create = async (endpoint, data) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("Error creating data:", error);
    throw error;
  }
};

export const update = async (endpoint, data) => {
  try {
    const response = await apiClient.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("Error updating data:", error);
    throw error;
  }
};

export const remove = async (endpoint) => {
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error deleting data:", error);
    throw error;
  }
};
